
(function(){
  const MAX_MOBILE = 768;
  const ID = 'jl-sticky-atc';
  function makeBar() {
    if (window.innerWidth > MAX_MOBILE) return;
    if (document.getElementById(ID)) return;
    const form = document.querySelector('form[action*="/cart/add"], form[action*="/cart"], form.product-form, form[id*="product"]');
    if (!form) return;
    const addBtn = form.querySelector('button[type="submit"], button[data-add-to-cart], input[type="submit"]');
    if (!addBtn) return;
    const bar = document.createElement('div');
    bar.id = ID;
    bar.style.position = 'fixed';
    bar.style.left = '0';
    bar.style.right = '0';
    bar.style.bottom = '0';
    bar.style.zIndex = '9999';
    bar.style.display = 'flex';
    bar.style.alignItems = 'center';
    bar.style.justifyContent = 'space-between';
    bar.style.padding = '10px 14px';
    bar.style.boxShadow = '0 -6px 20px rgba(0,0,0,0.12)';
    bar.style.background = '#fff';
    const img = document.querySelector('.product-media-container img, .product__media img, .media img, img[src*="product"]');
    if (img) {
      const thumb = document.createElement('img');
      thumb.src = img.src;
      thumb.style.width = '48px';
      thumb.style.height = '48px';
      thumb.style.objectFit = 'cover';
      thumb.style.borderRadius = '6px';
      thumb.style.marginRight = '10px';
      bar.appendChild(thumb);
    }
    const info = document.createElement('div');
    info.style.flex = '1';
    info.style.minWidth = '0';
    const title = document.querySelector('h1.product__title, h1.product-title, h1');
    const name = title ? title.innerText.trim() : '';
    if (name) {
      const nameEl = document.createElement('div');
      nameEl.textContent = name;
      nameEl.style.fontWeight = '600';
      nameEl.style.fontSize = '14px';
      nameEl.style.lineHeight = '1.2';
      nameEl.style.color = '#111';
      info.appendChild(nameEl);
    }
    const priceWrap = document.createElement('div');
    priceWrap.style.fontSize = '12px';
    priceWrap.style.color = '#555';
    const p = document.querySelector('.price, .product__price, .product-price');
    priceWrap.textContent = p ? p.innerText.trim().replace(/\s+/g, ' ') : '';
    info.appendChild(priceWrap);
    bar.appendChild(info);
    const btn = addBtn.cloneNode(true);
    btn.addEventListener('click', function(e) { e.preventDefault(); addBtn.click(); });
    bar.appendChild(btn);
    document.body.appendChild(bar);
    const spacer = document.createElement('div');
    spacer.id = ID + '-spacer';
    spacer.style.height = bar.offsetHeight + 'px';
    document.documentElement.style.scrollPaddingBottom = spacer.style.height;
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', makeBar); } else { makeBar(); }
  window.addEventListener('resize', function() {
    const bar = document.getElementById(ID);
    if (window.innerWidth > MAX_MOBILE && bar) { bar.remove(); }
    else if (!bar) { makeBar(); }
  });
}());
